import { httpGET, httpPOST } from './utils'
import { FRIENDS_LOCALIZATION_URL } from './constants'
import { app_state } from './app_state'
import { app_log } from './app_log';


function getRandomColor() {
    const letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

function getRandomName() {
    const ff_name_list = ["Puma", "Gratin", "Poireaux", "Cacahouète", "Crouton", "Prout", "Schtroumpf"];
    const ff_adjective_list = ["musqué.e", "slipoté.e", "débordé.e", "chocolaté.e", "doré.e", "sacré.e", "congelé.e"];
    const rand1 = Math.floor(Math.random() * Math.floor(ff_name_list.length-1));
    const rand2 = Math.floor(Math.random() * Math.floor(ff_adjective_list.length-1));
    return ff_name_list[rand1] + " " + ff_adjective_list[rand2];
}

// sample time to get and send new data
const REFRESH_PERIOD = 1000;  // ms
// timeout before giving up the connection with the server
const TRY_REPEAT_MAX = 60e3 / REFRESH_PERIOD;  // ms

export const APIFriendsLocalization = {
    user_id: localStorage.getItem("ff_user_id") ? parseInt(localStorage.getItem("ff_user_id")) : Date.now(),
    user_name: localStorage.getItem("ff_user_name") ? localStorage.getItem("ff_user_name") : getRandomName(),
    current_location: [],
    friends: new Map(),
    is_enabled: false,
    try_counter: 0,

    OnLocationUpdated: [],
    OnStateChanged: [],
    OnNewFriend: [],
    OnLostFriend: [],

    pushCurrentLocalization() {
        httpPOST(FRIENDS_LOCALIZATION_URL + "/setPosition", 
            {
                user_id: this.user_id,
                location_lon: app_state.last_location.lng,
                location_lat: app_state.last_location.lat,  // use a callback instead of raw accessor ?
            },
        )
        .then(() => { this.try_counter = 0; })
        .catch((err) => {
            /* eslint-disable no-console */
            console.log("Friend service unavailable: " + err);
            /* eslint-enable no-console */
            if (this.try_counter++ === TRY_REPEAT_MAX) {
                app_log.error("Failed to join ff server :(");
                this.is_enabled = false;
            }
        })
        .finally(() => {
            if (this.is_enabled) {
                // enable timer
                setTimeout(APIFriendsLocalization.pushCurrentLocalization.bind(this), REFRESH_PERIOD);
            }
        });
    },

    fetchFriendsLocalization() {
        httpGET(FRIENDS_LOCALIZATION_URL + "/getFriendsPosition")
        .then((ret) => {
            this.try_counter = 0;
            const res = JSON.parse(ret);
            let known_friend = Array.from(this.friends.keys());
            for (const user_id_str of Object.keys(res)) {
                const user_id = parseInt(user_id_str);
                if (this.friends.has(user_id)) {  // most common case
                    let f = this.friends.get(user_id);
                    f.position = res[user_id].position;
                    f.user_name = res[user_id].user_name;
                    f.delta_ts = res[user_id].delta_ts;
                    known_friend.splice(known_friend.indexOf(user_id), 1);
                }
                else if (user_id === this.user_id) continue;  // it's me !
                else {  // a new challenger appeared !
                    this.friends.set(user_id,   {   position: res[user_id].position,
                                                    user_name: res[user_id].user_name,
                                                    color: getRandomColor(),
                                                    timestamp: res[user_id].timestamp,
                                                    delta_ts: res[user_id].delta_ts,
                                                });
                    // trigger callback
                    const f_data = this.friends.get(user_id);
                    for (let cb of this.OnNewFriend) {
                        cb(user_id, f_data);
                    }
                    known_friend.splice(known_friend.indexOf(user_id), 1);
                }
            }
            for (const lost_friend of known_friend) {
                for (let cb of this.OnLostFriend) {
                    cb(lost_friend);
                }
                this.friends.delete(lost_friend);
            }            
            for (let cb of this.OnLocationUpdated) {
                cb(this.friends);
            }
        })
        .catch((err) => {
            /* eslint-disable no-console */
            console.log("Failed to fetch friends position: " + err);
            /* eslint-enable no-console */
            if (this.try_counter++ === TRY_REPEAT_MAX) {
                app_log.error("Failed to join ff server :(");
                this.is_enabled = false;
            }
        })
        .finally(() => {
            if (this.is_enabled) {
                // enable timer
                setTimeout(APIFriendsLocalization.fetchFriendsLocalization.bind(this), REFRESH_PERIOD);
            }
        });        
    },

    enable() {
        httpPOST(FRIENDS_LOCALIZATION_URL + "/hello", 
            {
                user_id: this.user_id,
                user_name: this.user_name,
                location_lon: app_state.last_location.lng,
                location_lat: app_state.last_location.lat,
            },
        )
        .then(() => {
            this.is_enabled = true;
            this.try_counter = 0;
            this.fetchFriendsLocalization();
            this.pushCurrentLocalization();
            // call API listeners:
            for (let cb of this.OnStateChanged) {
                cb(true);
            }
        })
        .catch((err) => {
            this.disable();
            /* eslint-disable no-console */
            console.log("Friend service unreachable: " + err);
            /* eslint-enable no-console */
            app_log.error("Failed to join ff server :(");
        });
    },

    disable() {
        httpPOST(FRIENDS_LOCALIZATION_URL + "/goodbye", 
            {
                user_id: this.user_id
            },
        )
        .catch((err) => {
            /* eslint-disable no-console */
            console.log("Friend service unreachable: " + err);
            /* eslint-enable no-console */
            app_log.error("Failed to join ff server :(");
        })
        .finally(() => {
            // this will automatically prevent next call:
            this.is_enabled = false;
            setTimeout(() => {
                // call API listeners:
                for (let cb of this.OnStateChanged) {
                    cb(false);
                }
                this.friends = new Map();
            }, REFRESH_PERIOD); 
        });
    },

    setName(name) {
        if (this.is_enabled) {
            this.disable();  // force call to goodbye
            this.user_name = name;
            this.enable();  // re-register to the server
        } else {
            this.user_name = name;
        }
    },

    save() {
        localStorage.setItem("ff_user_id", this.user_id);
        localStorage.setItem("ff_user_name", this.user_name);
    }
}